<template>
    <div class="container">
        <div class="paramForm">
            <el-form :model="params" label-width="90px">
                <el-row>
                    <el-form-item label="类型">
                        <el-select v-model="params.category" clearable>
                            <el-option key="1" label="借贷池结算" value="1"></el-option>
                            <el-option key="2" label="杠杆池结算" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="会员地址">
                        <el-input v-model="params.memberAddress" clearable  class="param-address"></el-input>
                    </el-form-item>
                    <el-form-item label="结算日期">
                        <el-date-picker v-model="params.createdAt" type="date" placeholder="选择结算日期"> </el-date-picker>
                    </el-form-item>
                </el-row>
            </el-form>
            <div class="paramFormButton">
                <el-button type="primary" icon="el-icon-search" @click="handleCurrentChange(1)">搜索</el-button>
                <el-button type="primary" @click="tokenProfitTask">执行结算</el-button>
            </div>
        </div>
        <div class="tableTool">
            <el-button type="primary" icon="el-icon-printer" @click="exportExcel">导出</el-button>
        </div>
        <el-table border ref="tableRef" id="out-table" :data="tableData" class="table-show-current" highlight-current-row>
            <el-table-column align="center" prop="id" label="ALD奖励结算ID" width="150"></el-table-column>
            <el-table-column align="center" label="会员地址" width="150" class-name="address">
                <template slot-scope="scope" v-if="scope.row.memberAddress">
                    <span  v-clipboard:copy="scope.row.memberAddress" v-clipboard:success="onCopy">
                        {{scope.row.memberAddress.slice(0,5) + "..." + scope.row.memberAddress.slice(-5)}}<i class="el-icon-document-copy"/>
                    </span>
                </template>
            </el-table-column>
            <el-table-column align="center" prop="createdAt" label="结算日" width="150">
                <template slot-scope="scope">{{ formatDate2(new Date(scope.row.createdAt)) }}</template>
            </el-table-column>
            <el-table-column align="center" label="总收益">
                <template slot-scope="scope">{{ toDecimalVal(scope.row.total,4) }} ALD</template>
            </el-table-column>
            <el-table-column align="center" label="已释放">
                <template slot-scope="scope">{{ toDecimalVal(scope.row.released,4) }} ALD</template>
            </el-table-column>
            <el-table-column align="center" label="已释放次数">
                <template slot-scope="scope">{{ scope.row.timesDone }}</template>
            </el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination
                background
                layout="total,sizes, prev, pager, next"
                :current-page="pageInfo.pageNum"
                :page-size="pageInfo.pageSize"
                :page-sizes="[10, 20, 50, 100, 200]"
                :total="total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
import { aldServiceApi } from '@/api/api-ald';
import { exportData1,exportData2 } from '@/assets/js/exportExcel';
export default {
    data() {
        return {
            params: {},
            total:0,
            pageInfo: {
                pageNum: 1,
                pageSize: 10
            },
            tableData:[],
        };
    },
    created() {
        this.handleSearch();
    },
    methods: {
        onCopy() {
            this.$message.success({message: "复制成功",duration: 600})
        },
        handleSizeChange(val) {
            this.pageInfo.pageSize = val;
            this.handleSearch();
        },
        handleCurrentChange(val) {
            this.pageInfo.pageNum = val;
            this.handleSearch();
        },
        handleSearch() {
            if(this.params.createdAt){
                this.params.createdAt = this.formatDate(new Date(this.params.createdAt))
            }
            aldServiceApi.findTokenProfitPageList(this.params,this.pageInfo).then(res => {
                this.tableData = res.records;
                this.total = res.total || 0;
            });
        },
        tokenProfitTask(){
            aldServiceApi.tokenProfitTask().then(res => {
                if (res.result) {
                    this.handleSearch()
                    this.$message.success("结算完成");
                } else {
                    if(res.msg){
                        this.$message.error(res.msg);
                    }else{
                        this.$message.error("结算失败");
                    }
                }
            });
        },
        exportExcel() {
            if(!this.isSuper){
                return;
            }
            if(!this.tableData || this.tableData.length==0){
                this.$message.warning({message: "没有可导出的数据",duration: 600})
                return;
            }
            let header = ['结算ID', '会员地址', '直推地址', '商户地址', '订单ID', '结算日',"总收益(RWAS)","已释放(RWAS)","线性释放次数","总收益(ETH)"];
            let columns = ['id', 'memberAddress', 'parentAddress', 'leaderAddress', 'orderId', 'createdAt',"tokenTotal","tokenReleased","linearReleaseTimes","ethTotal"];
            let data = this.tableData.map(r => columns.map(c => {
                if(c == 'createdAt'){
                    return this.formatDate2(new Date(r[c]));
                }else{
                    let val = r[c];
                    if(typeof val === 'number'){
                        return this.toDecimalVal(val,10);
                    }
                    return val;
                }   
            }));
            exportData2(header,data,"结算记录");
        }
    }
};
</script>

<style lang='less' scope>
span.status_CANCEL{
    color:red;
}
span.status_CONFIRM{
    color:green;
}
span.status_PENDING{
    color:gray;
}
</style>